<template>

	<div>
		<div class="header-item">
			<DropDown :title="title" :mainslug="slug" :content="content"></DropDown>
		</div>

		<router-view :content="allContent" :filtered="content"></router-view>
	</div>

</template>

<script>

import DropDown from '../components/DropDown.vue'
import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'objects',
	components: {
		'DropDown': DropDown
	},

	data () {
		return {
			content: null,
			allContent: null,
			title: 'Submissons',
			slug: 'submissions'
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			var dataLength = data.meta.count
			this.allContent = Object.values(data.data)

			// select only contentType = content
			var dataFiltered = []
			var int = 0
			for (var key in data.data) {
				int++
				if (data.data[key].settings) {
					if (data.data[key].settings.contentType) {
						if (data.data[key].settings.contentType.value === 'submissions') dataFiltered.push(data.data[key])
					}
				}
				if (int === dataLength) {
					this.content = dataFiltered
				}
			}
		}
	}
}
</script>
